import React, { useEffect, useState } from "react";
import { IconMenu, IconClose } from "./Icons";

const LINKS = [
  { href: "#gallery", label: "Gallery" },
  { href: "#location", label: "Location" },
  { href: "#about", label: "About" },
  { href: "#services", label: "Amenities" },
  { href: "#reviews", label: "Reviews" },
  { href: "#contact", label: "Contact" },
];

export const Navigation = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && setOpen(false);
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  const go = (e, href) => {
    e.preventDefault();
    setOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <>
      <a className="skip-link" href="#main">
        Skip to content
      </a>

      <nav className={`nav ${scrolled ? "nav--solid" : "nav--transparent"}`} aria-label="Main">
        <div className="nav__inner">
          <a className="nav__brand" href="#top" onClick={(e) => go(e, "#top")}>
            <img
              className="nav__mark"
              src="/img/logo.png"
              alt=""
              width="38"
              height="38"
              aria-hidden="true"
            />
            Casa Carmela
          </a>

          <ul className="nav__links">
            {LINKS.map((l) => (
              <li key={l.href}>
                <a className="nav__link" href={l.href} onClick={(e) => go(e, l.href)}>
                  {l.label}
                </a>
              </li>
            ))}
            <li>
              <a
                className="btn btn--accent btn--sm nav__cta"
                href="#booking"
                onClick={(e) => go(e, "#booking")}
              >
                Book now
              </a>
            </li>
          </ul>

          <button
            type="button"
            className="nav__toggle"
            aria-label="Open menu"
            aria-expanded={open}
            onClick={() => setOpen(true)}
          >
            <IconMenu />
          </button>
        </div>
      </nav>

      <div
        className={`drawer ${open ? "drawer--open" : ""}`}
        onClick={(e) => e.target === e.currentTarget && setOpen(false)}
        aria-hidden={!open}
      >
        <div className="drawer__panel" role="dialog" aria-modal="true" aria-label="Menu">
          <div className="drawer__head">
            <span className="drawer__title">Casa Carmela</span>
            <button
              type="button"
              className="drawer__close"
              aria-label="Close menu"
              onClick={() => setOpen(false)}
            >
              <IconClose />
            </button>
          </div>
          {LINKS.map((l) => (
            <a key={l.href} className="drawer__link" href={l.href} onClick={(e) => go(e, l.href)}>
              {l.label}
            </a>
          ))}
          <a className="btn btn--accent" href="#booking" onClick={(e) => go(e, "#booking")}>
            Book your stay
          </a>
        </div>
      </div>
    </>
  );
};

export default Navigation;
